/*=========================================================================================
  File Name: moduleEcommerceActions.js
  Description: Ecommerce Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "../../http/axios";

export default {


    login({commit},dados) {
      return new Promise((resolve, reject) => {
        axios.post("/api/loginIntegracao",dados)
          .then((response) => {
            localStorage.setItem('integracaoLogged',JSON.stringify(response.data))
            resolve(response);
          })
          .catch((error) => {
            reject(error)
          })
      })
  },
    getPaginas({commit}) {
      return new Promise((resolve, reject) => {
        axios.get("/api/paginas")
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error)
          })
      })
  },

}
